import { lazy } from "react";

import {
  EMAIL_VERIFICATION_PATH,
  INVITATION_DECISION_PATH,
  LOGIN_PATH,
  PASSWORD_RESET_PATH,
  REQUEST_PASSWORD_RESET_PATH,
  SIGNUP_PATH,
  SOCIAL_CALLBACK_PATH,
  VERIFY_TWO_FA_PATH,
  VERIFY_YOUR_EMAIL,
} from "./paths";

const InvitationDecision = lazy(
  () => import("@src/modules/member/modules/main/invitation-decision"),
);
const Login = lazy(() => import("@src/modules/member/modules/main/auth/login"));
const RequestPasswordReset = lazy(
  () => import("@src/modules/member/modules/main/auth/request-password-reset"),
);
const ResetPassword = lazy(
  () => import("@src/modules/member/modules/main/auth/reset-password"),
);
const Signup = lazy(
  () => import("@src/modules/member/modules/main/auth/signup"),
);

const VerifyTwoFactorAuth = lazy(
  () => import("@src/modules/member/modules/main/auth/verify-two-fa"),
);

const EmailVerification = lazy(
  () => import("../auth/email-verification/email-verification"),
);

const SocialCallback = lazy(
  () => import("@src/modules/member/modules/main/auth/social-callback"),
);

const VerifyYourEmail = lazy(
  () => import("../auth/email-verification/verify-your-email"),
);

const unprotectedMemberRoutes = [
  {
    path: INVITATION_DECISION_PATH(),
    element: <InvitationDecision />,
  },
  {
    path: LOGIN_PATH(),
    element: <Login />,
  },
  {
    path: PASSWORD_RESET_PATH(),
    element: <ResetPassword />,
  },
  {
    path: REQUEST_PASSWORD_RESET_PATH(),
    element: <RequestPasswordReset />,
  },
  {
    path: SIGNUP_PATH(),
    element: <Signup />,
  },
  {
    path: SOCIAL_CALLBACK_PATH(),
    element: <SocialCallback />,
  },
  {
    path: VERIFY_TWO_FA_PATH(),
    element: <VerifyTwoFactorAuth />,
  },
  {
    path: VERIFY_YOUR_EMAIL(),
    element: <VerifyYourEmail />,
  },
  {
    path: EMAIL_VERIFICATION_PATH(),
    element: <EmailVerification />,
  },
];

export default unprotectedMemberRoutes;
